import React from "react";
import Carousel from "../components/molecules/Carousel";

import { Link } from "react-router-dom";
import { SEE_RESULTS } from "../constants/routesPaths";
import CTAButton from "../components/molecules/CTAButtons";
import { COLLECTION_NAME, getIPAddress, PROJECT_NAME, serviceAdvertiser, servicePetDetail, TRACKING_PARTNER, TRACKING_REFUGE } from "../constants/constants";
import DogDetails from "../models/DogDetails";
import Loading from "../components/Loading";
import Footer from "../components/Footer";
import { analytics, db } from "../firebase.config";

import facebookIcon from "../assets/svgs/facebook_black_icon.svg";
import instagramIcon from "../assets/svgs/instagram_black_icon.svg";
import websiteIcon from "../assets/svgs/website_black_icon.svg";
import whatsappIcon from "../assets/svgs/whatsapp_black_icon.svg";
import phoneIcon from "../assets/svgs/phone_black_icon.svg";
import twitterIcon from "../assets/svgs/twitter_black_icon.svg";
import greenCheck from "../assets/svgs/green_check_circle.svg";
import redCancel from "../assets/svgs/red_cancel_circle.svg";
import petHouse from "../assets/svgs/pet_adoption_house.svg";
import closeModal from "../assets/svgs/close_grey_icon.svg";
import noResults from "../assets/images/noresults_profile.png";

import { defaultAd } from "../constants/defaultAd";
import { RefugeData } from "../models/RefugeData";
import Navbar from "../components/Navbar";
import DataNormalization from "../utils/DataNormalization";
import Tracking from "../models/Tracking";
import { browserName, deviceType, isMobile, mobileVendor, osName } from "react-device-detect";
import ManageStorage from "../utils/manageStorage";
import Notifications from "../components/molecules/Notifications";
import AdDetails from "../models/AdDetails";
import { SocialMediaContact } from "../utils/SocialMediaContact";
import IconButton from "../components/molecules/IconButton";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton, WhatsappShareButton, WhatsappIcon } from "react-share";
import { Helmet } from "react-helmet";

class DogProfile extends React.Component {
  storage = new ManageStorage();
  dogData = {};
  adSpace = {};
  refugeData = {};
  socialMediaLink;
  refugeMediaLink;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingAd: false,
      humanData: {
        name: "",
        email: "",
      },
      showRefuge: false,
      showNotification: false,
      showCopyNotification: false,
      showPetOpportunity: false,
    };
  }

  /**
   * Obtain the data from the pet
   *
   * @returns Promise
   */
  async getDogProfile(dogId) {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      body: JSON.stringify({ id: dogId }),
      headers: headers,
    };

    const response = await fetch(servicePetDetail, options);
    if (response.ok) {
      return response.json();
    } else {
      analytics.logEvent(`Page_NotFound_DogProfile`, {
        item: this.props.match.url
      });
      return {};
    }
  }

  async getAds() {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      body: JSON.stringify({
        id: -1
      }),
      headers: headers,
    };

    const response = await fetch(serviceAdvertiser, options);
    if (response.ok) {
      return response.json();
    } else {
      return defaultAd;
    }

  }

  componentDidMount() {
    document.title = `Adopcion de mascotas en Guatemala | ${PROJECT_NAME}`;
    analytics.logEvent(`Page_PetProfile`, {
      item: this.props.match.url
    });
    window.scrollTo(0, 0);

    if (DataNormalization.getRandomInt(10) % 3 === 0) {
      setTimeout(() => {
        this.setState({
          showPetOpportunity: true
        });
        setTimeout(() => {
          this.setState({
            showPetOpportunity: false
          });
        }, 4000);
      }, 4000);
    }

    this.getAds().then((data) => {
      // Ad data
      // console.log(data);
      this.adSpace = data;
      this.socialMediaLink = new SocialMediaContact({
        data: this.adSpace,
      });
      this.setState({
        loadingAd: true
      });
    });

    this.getDogProfile(this.props.match.params.id).then((data) => {
      // console.log(data);
      this.dogData = data;
      this.refugeData = data[DogDetails.refuge];

      this.refugeMediaLink = new SocialMediaContact({
        data: this.refugeData,
        petData: this.dogData,
        objectDetails: RefugeData
      });
      this.setState({
        loading: true,
      });
    });

    if (typeof this.storage.data['humandata'] !== "undefined") {
      this.setState({
        humanData: this.storage.data['humandata'],
      })
    }
  }

  handleInputName = (event) => {
    let humanData = {
      name: event.target.value,
      email: this.state.humanData.email,
    };
    this.setState({ humanData: humanData });
  };

  handleInputEmail = (event) => {
    let humanData = {
      name: this.state.humanData.name,
      email: event.target.value,
    };
    this.setState({ humanData: humanData });
  };

  verifyHumanData = () => {
    const verifyHuman = this.checkHumanData();

    if (verifyHuman === true) {
      this.setState({
        showRefuge: true,
      });

      this.saveHumanInterest(this.refugeData[RefugeData.objectname]);
    } else {
      this.setState({
        showRefuge: false,
        showNotification: true,
      });

      setTimeout(()=> {
        this.setState({
          showNotification: false,
        })
      }, 4000);
    }
  };

  checkHumanData = () => {
    const humanData = this.state.humanData;
    if (humanData.name !== "" && humanData.email !== "") {
      if (this.validateEmail(humanData.email) || this.validatePhoneNumber(humanData.email)) {
        return true;
      } else {
        return "Ingresa un correo o teléfono válido"
      }
    } else {
      return "Ingresa tus datos para ver información de adopción de tu futura mascota";
    }
  }

  validateEmail = (email) => {
    const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return res.test(String(email).toLowerCase());
  }

  validatePhoneNumber = (phone) => {
    const res = /^[0-9]{8}$/;
    return res.test(String(phone).toLowerCase());
  }

  closeModal = () => {
    this.setState({
      showRefuge: false
    });
  }

  getDateCollection() {
    const tempDate = new Date();
    const date = (tempDate.getMonth()+1) + '-' + tempDate.getDate()  + '-' + tempDate.getFullYear();

    return date;
  }

  manageHumanDataStorage() {
    const storageData = this.storage.data;
    const humanData = {
      name: this.state.humanData.name,
      email: this.state.humanData.email,
    }

    storageData['humandata'] = humanData;
    this.storage.items = storageData;
  }

  saveHumanInterest(refugeName) {
    analytics.logEvent(`Action_HumanInterest`, {
      item: this.dogData[DogDetails.id]
    });

    this.manageHumanDataStorage();

    db.collection(COLLECTION_NAME).doc(this.getDateCollection()).collection(refugeName).doc(this.state.humanData.email).get().then((data) => {
      const petData = data.data();
      if (typeof petData === 'undefined') {
            db.collection(COLLECTION_NAME).doc(this.getDateCollection()).set({}).then((data) => {
              db.collection(COLLECTION_NAME).doc(this.getDateCollection()).collection(refugeName).doc(this.state.humanData.email).set({
                name: this.state.humanData.name,
                email: this.state.humanData.email,
                petsID: [this.dogData[DogDetails.id]]
              });
            });
      } else {
        const petsId = petData.petsID;
        if (petsId.indexOf(this.dogData[DogDetails.id]) === -1) {
          petsId.push(this.dogData[DogDetails.id]);
          // console.log(petsId);
          db.collection(COLLECTION_NAME).doc(this.getDateCollection()).collection(refugeName).doc(this.state.humanData.email).set({
            name: this.state.humanData.name,
            email: this.state.humanData.email,
            petsID: petsId
          });
        }
      }
    });
    
  }

  async clickOverPetPartner(id, name) {

    analytics.logEvent(`Action_PetProfileAdVet`, {
      item: name
    });

    let ipAddress = await fetch(getIPAddress, {
      method: "GET",
    }).then((data) => {
      return data.json();
    });
    
    // TRACKING PARA 0 NO_RESULTS
    let tracking = new Tracking({
      eventName: TRACKING_PARTNER,
      filters: this.storage.data,
      browser: browserName,
      device: deviceType,
      source: this.props.location.pathname,
      objectId: id,
      ip: ipAddress.IPv4,
      osName: osName,
      mobileVendor: isMobile? mobileVendor: 'notMobile',
      state: ipAddress.state,
    });

    tracking.trackingPetClick();
  }

  /**
   * 
   * @param {String} id Refugee ID
   */
  async clickOverContactRefugee(id) {

    analytics.logEvent(`Action_ContactRefuge`, {
      petId: this.dogData[DogDetails.id],
      refugeId: id
    });

    let ipAddress = await fetch(getIPAddress, {
      method: "GET",
    }).then((data) => {
      return data.json();
    });

    let tracking = new Tracking({
      eventName: TRACKING_REFUGE,
      filters: this.storage.data,
      browser: browserName,
      device: deviceType,
      source: this.props.location.pathname,
      objectId: id,
      ip: ipAddress.IPv4,
      osName: osName,
      mobileVendor: isMobile? mobileVendor: 'notMobile',
      state: ipAddress.state,
    });
    
    tracking.trackingPetClick();
    // this.props.history.push(this.refugeMediaLink.buildLink());
  }

  handleAction() {
    analytics.logEvent(`Action_NoPetBackToResults`, {});
    this.props.history.push(SEE_RESULTS);
  }

  showNotificationCopy() {
    this.setState({
      showCopyNotification: true,
    });

    setTimeout(()=> {
      this.setState({
        showCopyNotification: false,
      })
    }, 4000);
  }

  shareButtonClick() {
    const shareInputValue = document.querySelector('.dogProfile-information-share_input');
    analytics.logEvent(`Action_ShareButton`, {
      item: shareInputValue.value
    });
    shareInputValue.select();
    document.execCommand("copy");
    this.showNotificationCopy();
  }

  render() {
    let countPetImages = 0;
    return (
      <div>
        {this.state.loading === false && <Loading />}
        {this.state.loading === true && (
          <React.Fragment>
            <Navbar whiteVersion={true} customClasses={"navbar--relative"}>
              <Link
                to={SEE_RESULTS}
                className={
                  "navbar__links navbar__links--button navbar__links--button-green-bggreen"
                }
              >
                <div className={"navbar__links--button-container"}>
                  {/* <img src={filterIcon} alt={"Icono ajustar búsqueda"} /> */}
                  <span>Volver a resultados</span>
                </div>
              </Link>
            </Navbar>
            {this.state.loading === true &&
              Object.keys(this.dogData).length === 0 && (
                <div className={"dogProfile__noresults"}>
                  <img
                    className={"dogProfile__noresults-image"}
                    src={noResults}
                    alt={"Esta mascota aun no existe"}
                  />
                  <h2 className={"dogProfile__noresults-title"}>
                    Aún no tenemos esta mascota
                  </h2>
                  <div className={"dogProfile__noresults-texts"}>
                    <p>La mascota que buscas aún no está con nosotros.</p>
                    <p>
                      Vuelve a los resultados para encontrar tu futura mascota.
                    </p>
                  </div>
                  <CTAButton
                    buttonText={"Volver a resultados"}
                    onAction={this.handleAction.bind(this)}
                  />
                </div>
              )}
            {this.state.loading === true &&
              Object.keys(this.dogData).length > 0 && (
                <div>
                  <Helmet>
                    <title>
                      Adopcion de mascotas en Guatemala |{" "}
                      {this.dogData[DogDetails.petname]}
                    </title>
                    <meta
                      name="description"
                      content={`Dale la oportunida de un nueva hogar a ${
                        this.dogData[DogDetails.petname]
                      } en adoptzi.com. Sexo: ${DataNormalization.petSexString(
                        this.dogData[DogDetails.sex]
                      )} Edad: ${DataNormalization.petAge(
                        this.dogData[DogDetails.age]
                      )} Tamaño: ${DataNormalization.petSizeString(
                        this.dogData[DogDetails.size],
                        this.dogData[DogDetails.sex]
                      )}`}
                    />
                    <meta
                      property="og:title"
                      content={`Adopcion de mascotas en Guatemala | ${
                        this.dogData[DogDetails.petname]
                      }`}
                    />
                    <meta
                      property="og:description"
                      content={`Dale la oportunida de un nueva hogar a ${
                        this.dogData[DogDetails.petname]
                      } en adoptzi.com. Sexo: ${DataNormalization.petSexString(
                        this.dogData[DogDetails.sex]
                      )} Edad: ${DataNormalization.petAge(
                        this.dogData[DogDetails.age]
                      )} Tamaño: ${DataNormalization.petSizeString(
                        this.dogData[DogDetails.size],
                        this.dogData[DogDetails.sex]
                      )}`}
                    />
                    <meta
                      property="og:url"
                      content={`https://adoptzi.com/mascotas/${
                        this.dogData[DogDetails.id]
                      }/`}
                    />
                    <meta property="og:site_name" content="Adoptzi" />
                    <meta
                      property="og:image"
                      content={this.dogData[DogDetails.image][0]}
                    />
                    <meta
                      property="og:image:secure_url"
                      content={this.dogData[DogDetails.image][0]}
                    />
                    <meta name="twitter:site" content="@adoptzi" />
                    <meta name="twitter:creator" content="@adoptzi" />
                    <meta
                      name="twitter:title"
                      content={`Adopcion de mascotas en Guatemala | ${
                        this.dogData[DogDetails.petname]
                      }`}
                    />
                    <meta
                      name="twitter:description"
                      content={`Dale la oportunida de un nueva hogar a ${
                        this.dogData[DogDetails.petname]
                      } en adoptzi.com. Sexo: ${DataNormalization.petSexString(
                        this.dogData[DogDetails.sex]
                      )} Edad: ${DataNormalization.petAge(
                        this.dogData[DogDetails.age]
                      )} Tamaño: ${DataNormalization.petSizeString(
                        this.dogData[DogDetails.size],
                        this.dogData[DogDetails.sex]
                      )}`}
                    />
                    <meta
                      name="twitter:image"
                      content={this.dogData[DogDetails.image][0]}
                    />
                  </Helmet>
                  <Notifications
                    text={`${this.checkHumanData()}`}
                    customClasses={`${
                      this.state.showNotification
                        ? "notifications--active notifications--error"
                        : ""
                    }`}
                  />
                  <Notifications
                    text={`Link copiado 👍🏻 ${"  "} Listo para ser compartirdo.`}
                    customClasses={`${
                      this.state.showCopyNotification
                        ? "notifications--active notifications--information"
                        : ""
                    }`}
                  />
                  <Notifications
                    text={`✨ Anímate en adoptar a ${
                      this.dogData[DogDetails.petname]
                    }. Presiona en ¡Quiero adoptar!✨`}
                    customClasses={`${
                      this.state.showPetOpportunity
                        ? "notifications--active notifications--information"
                        : ""
                    }`}
                  />

                  <div className={"dogProfile"}>
                    <Carousel>
                      {this.dogData[DogDetails.image].map((petImage) => {
                        countPetImages++;
                        return (
                          <div
                            key={`petImage-${countPetImages}`}
                            className={"pet-photo"}
                          >
                            <div className={"pet-photo-item"}>
                              <img
                                className={"pet-photo-background"}
                                src={petImage}
                                alt={"Foto de mascota"}
                              />
                              <img
                                className={"pet-photo-image"}
                                src={petImage}
                                alt={"Foto de mascota"}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </Carousel>

                    <div className={"dogProfile-information"}>
                      <div className={"dogProfile-information-container"}>
                        <div className={"build-columns"}>
                          <div className={"three-fifth-column"}>
                            <div
                              className={
                                "dogProfile-information-texts_container"
                              }
                            >
                              <h2
                                className={`${DogDetails.dogClassTitleAvailability(
                                  this.dogData[DogDetails.available]
                                )}`}
                              >
                                {DogDetails.dogAvailabilty(
                                  this.dogData[DogDetails.available],
                                  this.dogData[DogDetails.petname],
                                  this.dogData[DogDetails.sex]
                                )}
                              </h2>
                              <p>{this.dogData[DogDetails.description]}</p>
                            </div>
                          </div>
                          <div className={"one-fifth-column"}>
                            <div
                              className={
                                "dogProfile-information-details_container"
                              }
                            >
                              <div
                                className={
                                  "dogProfile-information-details_container-content"
                                }
                              >
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>Edad</span>
                                  {`${DataNormalization.petAge(
                                    this.dogData[DogDetails.age]
                                  )}`}
                                </p>
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>Sexo</span>
                                  {DataNormalization.petSexString(
                                    this.dogData[DogDetails.sex]
                                  )}
                                </p>
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>Tamaño</span>
                                  {DataNormalization.petSizeString(
                                    this.dogData[DogDetails.size],
                                    this.dogData[DogDetails.sex]
                                  )}
                                </p>
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>Pelaje</span>
                                  {DataNormalization.petFurString(
                                    this.dogData[DogDetails.fur]
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className={"one-fifth-column"}>
                            <div
                              className={
                                "dogProfile-information-moredetails_container"
                              }
                            >
                              <div
                                className={
                                  "dogProfile-information-moredetails_container-content"
                                }
                              >
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>Pet friendly</span>{" "}
                                  {this.dogData[DogDetails.otherpets] ? (
                                    <img
                                      src={greenCheck}
                                      alt="Si es amigable con otras mascotas"
                                    />
                                  ) : (
                                    <img
                                      src={redCancel}
                                      alt="No es amigable con otras mascotas"
                                    />
                                  )}{" "}
                                </p>
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>
                                    {DataNormalization.petVaccinated(
                                      this.dogData[DogDetails.vaccinated],
                                      this.dogData[DogDetails.sex]
                                    )}
                                  </span>{" "}
                                  {this.dogData[DogDetails.vaccinated] ? (
                                    <img
                                      src={greenCheck}
                                      alt="Si está vacunado"
                                    />
                                  ) : (
                                    <img
                                      src={redCancel}
                                      alt="No está vacunado"
                                    />
                                  )}{" "}
                                </p>
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>
                                    {DataNormalization.petFixed(
                                      this.dogData[DogDetails.castrado],
                                      this.dogData[DogDetails.sex]
                                    )}
                                  </span>{" "}
                                  {this.dogData[DogDetails.castrado] ? (
                                    <img
                                      src={greenCheck}
                                      alt="Si está castrado"
                                    />
                                  ) : (
                                    <img
                                      src={redCancel}
                                      alt="No está castrado"
                                    />
                                  )}{" "}
                                </p>
                                <p
                                  className={"dogProfile-information-text_item"}
                                >
                                  <span>
                                    {DataNormalization.petNoParasites(
                                      this.dogData[DogDetails.noparasites],
                                      this.dogData[DogDetails.sex]
                                    )}
                                  </span>{" "}
                                  {this.dogData[DogDetails.noparasites] ? (
                                    <img
                                      src={greenCheck}
                                      alt="Si está desparasitado"
                                    />
                                  ) : (
                                    <img
                                      src={redCancel}
                                      alt="No está desparasitado"
                                    />
                                  )}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={"petOpportunity"}>
                      <div className={"petOpportunity-container"}>
                        <div className={"petOpportunity-intro"}>
                          <img src={petHouse} alt="Adopta a tu mascota" />
                          <div className={"petOpportunity-intro-texts"}>
                            <p className={"petOpportunity-intro-subtitle"}>
                              ¿Quieres adoptarme?
                            </p>
                            <p className={"petOpportunity-intro-description"}>
                              Coloca tus datos para ver información de adopción
                              de tu futura mascota.
                            </p>
                          </div>
                        </div>
                        <div className={"petOpportunity-human_data"}>
                          <div className={"petOpportunity-human_data-item"}>
                            <label>Nombre</label>
                            <input
                              type={"text"}
                              placeholder={"Nombre"}
                              value={this.state.humanData.name}
                              onChange={this.handleInputName}
                            />
                          </div>
                          <div className={"petOpportunity-human_data-item"}>
                            <label>Correo o teléfono</label>
                            <input
                              type={"email"}
                              placeholder={"Correo o teléfono"}
                              value={this.state.humanData.email}
                              onChange={this.handleInputEmail}
                            />
                          </div>
                          <CTAButton
                            buttonText={"¡Quiero adoptar!"}
                            onAction={this.verifyHumanData.bind(this)}
                            actionValue={true}
                            image={"svgs/adoptzi_icon.svg"}
                            position={"right"}
                            customClasses={
                              "ctabutton--fixWidth petOpportunity-button"
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className={"build-columns"}>
                      <div className={"one-half-column"}>
                        <div
                          className={"dogProfile-information-share-container"}
                        >
                          <div
                            className={"dogProfile-information-share-content"}
                          >
                            <p
                              className={
                                "dogProfile-information-share-content_title"
                              }
                            >
                              ¡Ayúdame a encontrar un hogar!
                            </p>
                            <p
                              className={
                                "dogProfile-information-share-content_desc"
                              }
                            >
                              Copia el siguiente link para poder compartir a{" "}
                              {DataNormalization.firtsUpperOthersLower(
                                this.dogData[DogDetails.petname]
                              )}{" "}
                              y tenga la oportunidad de encontrar un hogar 🏡
                            </p>
                            <div
                              className={
                                "dogProfile-information-share-content_inputs"
                              }
                            >
                              <input
                                onClick={this.shareButtonClick.bind(this)}
                                className={"dogProfile-information-share_input"}
                                type={"text"}
                                value={`https://adoptzi.com/mascotas/${
                                  this.dogData[DogDetails.id]
                                }/`}
                                readOnly
                              />
                              <button
                                onClick={this.shareButtonClick.bind(this)}
                              >
                                Copiar
                              </button>
                            </div>
                          </div>
                          <div
                            className={
                              "dogProfile-information-share-socialMedia"
                            }
                          >
                            <div
                              className={
                                "dogProfile-information-share-socialMedia_texts"
                              }
                            >
                              <h3>Comparte en redes sociales</h3>
                              <p>Puedes compartir en:</p>
                            </div>
                            <div
                              className={
                                "dogProfile-information-share-socialMedia_container"
                              }
                            >
                              <FacebookShareButton
                                url={`https://adoptzi.com/mascotas/${
                                  this.dogData[DogDetails.id]
                                }/`}
                                quote={`Adopta a ${DataNormalization.firtsUpperOthersLower(
                                  this.dogData[DogDetails.petname]
                                )}. Dale una oportunidad para tener un hogar cálido y seguro.
                            Datos de mascota:
                            Sexo: ${DataNormalization.petSexString(
                              this.dogData[DogDetails.sex]
                            )}
                            Edad: ${DataNormalization.petAge(
                              this.dogData[DogDetails.age]
                            )}
                            Tamaño: ${DataNormalization.petSizeString(
                              this.dogData[DogDetails.size],
                              this.dogData[DogDetails.sex]
                            )}
                            Para ver más detalles, visita el link de la publicación.
                            `}
                                hashtag={
                                  "#adopcionperros #adopciongatos #adopcionperro #adopciongato #guatemala"
                                }
                              >
                                <FacebookIcon size={32} round={true} />
                              </FacebookShareButton>
                              <TwitterShareButton
                                url={`https://adoptzi.com/mascotas/${
                                  this.dogData[DogDetails.id]
                                }/`}
                                title={`Adopta a ${DataNormalization.firtsUpperOthersLower(
                                  this.dogData[DogDetails.petname]
                                )}. Dale una oportunidad para tener un hogar cálido y seguro.`}
                                hashtags={[
                                  "adopcionperros",
                                  "adopciongatos",
                                  "adopcionperro",
                                  "adopciongato",
                                  "guatemala",
                                ]}
                              >
                                <TwitterIcon size={32} round={true} />
                              </TwitterShareButton>
                              <WhatsappShareButton
                                url={`https://adoptzi.com/mascotas/${
                                  this.dogData[DogDetails.id]
                                }/`}
                                title={`Adopta a ${DataNormalization.firtsUpperOthersLower(
                                  this.dogData[DogDetails.petname]
                                )}. Dale una oportunidad para tener un hogar cálido y seguro. \n Datos de mascota: \n Sexo: ${DataNormalization.petSexString(
                                  this.dogData[DogDetails.sex]
                                )} \n Edad: ${DataNormalization.petAge(
                                  this.dogData[DogDetails.age]
                                )} \n Tamaño: ${DataNormalization.petSizeString(
                                  this.dogData[DogDetails.size],
                                  this.dogData[DogDetails.sex]
                                )} \n Para ver más detalles, visita el siguiente link:
                            `}
                              >
                                <WhatsappIcon size={32} round={true} />
                              </WhatsappShareButton>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={"one-half-column"}>
                        {/* ESPACIO DE ANUNCIO */}
                        {this.state.loadingAd === true && (
                          <div
                            key={"ads-for-pets"}
                            className={
                              "results_item-wrapper results_item-wrapper--fullWidth"
                            }
                          >
                            <div
                              className={
                                "results_item results_item--publicidad result_item--publicidad-fullwidth"
                              }
                            >
                              <div className={"results_item_image"}>
                                <img
                                  src={this.adSpace[AdDetails.image]}
                                  alt={"Publicidad Adoptzi"}
                                />
                              </div>
                              <div className={"results_item_information"}>
                                <div
                                  className={"results_item_information-text"}
                                >
                                  <div
                                    className={
                                      "results_item_information-properties"
                                    }
                                  >
                                    <span className={""}>Anuncio</span>
                                  </div>
                                  <p
                                    className={
                                      "results_item_information-text-title"
                                    }
                                  >
                                    {this.adSpace[AdDetails.objectname]}
                                  </p>
                                  <p
                                    className={
                                      "results_item_information-text-description"
                                    }
                                  >
                                    {this.adSpace[AdDetails.longDescription]}
                                  </p>
                                  <div className={"vet-menu-item--social"}>
                                    {typeof this.adSpace[AdDetails.socialMedia]
                                      .facebook !== "undefined" &&
                                      this.adSpace[AdDetails.socialMedia]
                                        .facebook !== "" && (
                                        <a
                                          className={
                                            "vet-menu-item--social-item"
                                          }
                                          target={"_blank"}
                                          rel={"noreferrer"}
                                          href={
                                            this.adSpace[AdDetails.socialMedia]
                                              .facebook
                                          }
                                        >
                                          <img
                                            src={facebookIcon}
                                            alt={"Facebook icon"}
                                          />
                                        </a>
                                      )}
                                    {typeof this.adSpace[AdDetails.socialMedia]
                                      .instagram !== "undefined" &&
                                      this.adSpace[AdDetails.socialMedia]
                                        .instagram !== "" && (
                                        <a
                                          className={
                                            "vet-menu-item--social-item"
                                          }
                                          target={"_blank"}
                                          rel={"noreferrer"}
                                          href={
                                            this.adSpace[AdDetails.socialMedia]
                                              .instagram
                                          }
                                        >
                                          <img
                                            src={instagramIcon}
                                            alt={"Instagram icon"}
                                          />
                                        </a>
                                      )}
                                    {typeof this.adSpace[AdDetails.socialMedia]
                                      .twitter !== "undefined" &&
                                      this.adSpace[AdDetails.socialMedia]
                                        .twitter !== "" && (
                                        <a
                                          className={
                                            "vet-menu-item--social-item"
                                          }
                                          target={"_blank"}
                                          rel={"noreferrer"}
                                          href={
                                            this.adSpace[AdDetails.socialMedia]
                                              .twitter
                                          }
                                        >
                                          <img
                                            src={twitterIcon}
                                            alt={"Twitter icon"}
                                          />
                                        </a>
                                      )}
                                    {typeof this.adSpace[AdDetails.socialMedia]
                                      .website !== "undefined" &&
                                      this.adSpace[AdDetails.socialMedia]
                                        .website !== "" && (
                                        <a
                                          className={
                                            "vet-menu-item--social-item"
                                          }
                                          target={"__blank"}
                                          href={
                                            this.adSpace[AdDetails.socialMedia]
                                              .website
                                          }
                                        >
                                          <img
                                            src={websiteIcon}
                                            alt={"Website icon"}
                                          />
                                        </a>
                                      )}
                                    {typeof this.adSpace[AdDetails.phone] !==
                                      "undefined" &&
                                      this.adSpace[AdDetails.phone] !== "" && (
                                        <a
                                          className={
                                            "vet-menu-item--social-item"
                                          }
                                          target={"_blank"}
                                          rel={"noreferrer"}
                                          href={`tel://${
                                            this.adSpace[AdDetails.phone]
                                          }`}
                                        >
                                          <img
                                            src={phoneIcon}
                                            alt={"Phone icon"}
                                          />
                                        </a>
                                      )}
                                  </div>
                                </div>
                                <IconButton
                                  buttonText={"Contactar"}
                                  goTo={this.socialMediaLink?.buildLink()}
                                  otherTab={true}
                                  onClick={() => {
                                    this.clickOverPetPartner(
                                      this.adSpace[AdDetails.id],
                                      this.adSpace[AdDetails.objectname]
                                    );
                                  }}
                                  customClasses={"results-cta-button"}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* MODAL REFUGE */}
                    <div
                      className={`petOpportunity-refuge_data${
                        this.state.showRefuge
                          ? " petOpportunity-refuge_data--active"
                          : ""
                      }`}
                    >
                      <div
                        className={`petOpportunity-refuge_data-modal${
                          this.state.showRefuge
                            ? " petOpportunity-refuge_data-modal--active"
                            : ""
                        }`}
                      >
                        <div
                          className={
                            "petOpportunity-refuge_data-modal_container"
                          }
                        >
                          <img
                            onClick={() => {
                              this.closeModal();
                            }}
                            className={"petOpportunity-refuge_data-modal_close"}
                            src={closeModal}
                            alt={"Cerrar ventana refugio"}
                          />
                          <img
                            src={this.refugeData[RefugeData.logo]}
                            alt={this.refugeData[RefugeData.objectname]}
                          />
                          <h2
                            className={"petOpportunity-refuge_data-modal_title"}
                          >
                            {this.refugeData[RefugeData.objectname]}
                          </h2>
                          <div
                            className={
                              "petOpportunity-refuge_data-modal_subtitle"
                            }
                          >
                            <h3>¡Gracias por interesarte en adoptar!</h3>
                            <p>
                              {this.refugeData[RefugeData.shortDescription]}
                            </p>
                          </div>
                          <div
                            className={"petOpportunity-refuge_data_container"}
                          >
                            <div className={"petOpportunity-refuge_data-item"}>
                              <h3>Correo</h3>
                              <a
                                href={`mailto:${
                                  this.refugeData[RefugeData.email]
                                }`}
                              >
                                <p>{this.refugeData[RefugeData.email]}</p>
                              </a>
                            </div>
                            {typeof this.refugeData[RefugeData.location] !==
                              "undefined" &&
                              this.refugeData[RefugeData.location] !== "" && (
                                <div
                                  className={"petOpportunity-refuge_data-item"}
                                >
                                  <h3>Direccion</h3>
                                  <p>{this.refugeData[RefugeData.location]}</p>
                                </div>
                              )}
                            <div className={"petOpportunity-refuge_data-item"}>
                              <h3>Teléfono</h3>
                              <a
                                href={`tel://${
                                  this.refugeData[RefugeData.phone]
                                }`}
                              >
                                <p>{this.refugeData[RefugeData.phone]}</p>
                              </a>
                            </div>
                            <div className={"petOpportunity-refuge_data-item"}>
                              <h3>Redes sociales</h3>
                              <div
                                className={
                                  "vet-menu-item--social vet-menu-item--social--flexstart"
                                }
                              >
                                {typeof this.refugeData[RefugeData.socialMedia]
                                  .facebook !== "undefined" &&
                                  this.refugeData[RefugeData.socialMedia]
                                    .facebook !== "" && (
                                    <a
                                      className={"vet-menu-item--social-item"}
                                      target={"_blank"}
                                      rel={"noreferrer"}
                                      href={
                                        this.refugeData[RefugeData.socialMedia]
                                          .facebook
                                      }
                                    >
                                      <img
                                        src={facebookIcon}
                                        alt={"Facebook icon"}
                                      />
                                    </a>
                                  )}
                                {typeof this.refugeData[RefugeData.socialMedia]
                                  .instagram !== "undefined" &&
                                  this.refugeData[RefugeData.socialMedia]
                                    .instagram !== "" && (
                                    <a
                                      className={"vet-menu-item--social-item"}
                                      target={"_blank"}
                                      rel={"noreferrer"}
                                      href={
                                        this.refugeData[RefugeData.socialMedia]
                                          .instagram
                                      }
                                    >
                                      <img
                                        src={instagramIcon}
                                        alt={"Instagram icon"}
                                      />
                                    </a>
                                  )}
                                {typeof this.refugeData[RefugeData.socialMedia]
                                  .whatsapp !== "undefined" &&
                                  this.refugeData[RefugeData.socialMedia]
                                    .whatsapp !== "" && (
                                    <a
                                      className={"vet-menu-item--social-item"}
                                      target={"_blank"}
                                      rel={"noreferrer"}
                                      href={
                                        this.refugeData[RefugeData.socialMedia]
                                          .whatsapp
                                      }
                                    >
                                      <img
                                        src={whatsappIcon}
                                        alt={"Whatsapp icon"}
                                      />
                                    </a>
                                  )}
                                {typeof this.refugeData[RefugeData.socialMedia]
                                  .website !== "undefined" &&
                                  this.refugeData[RefugeData.socialMedia]
                                    .website !== "" && (
                                    <a
                                      className={"vet-menu-item--social-item"}
                                      target={"_blank"}
                                      rel={"noreferrer"}
                                      href={
                                        this.refugeData[RefugeData.socialMedia]
                                          .website
                                      }
                                    >
                                      <img
                                        src={websiteIcon}
                                        alt={"Website icon"}
                                      />
                                    </a>
                                  )}
                              </div>
                            </div>
                          </div>
                          <a
                            target={"_blank"}
                            rel={"noreferrer"}
                            href={this.refugeMediaLink?.buildLink()}
                            onClick={() => {
                              this.clickOverContactRefugee(
                                this.refugeData[RefugeData.id]
                              );
                            }}
                            className={
                              "ctabutton ctabutton--fixWidth petOpportunity-refuge_data-contact_button"
                            }
                          >
                            Contactar
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer />
                </div>
              )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default DogProfile;
